// components
import { Navbar, Footer } from "@/components";
import { ProfileView } from "@/components/profile-view";

export default function ProfilePage() {
  return (
    <>
      <Navbar />
      <ProfileView />
      <Footer />
    </>
  );
}

